import React, { Component } from 'react';
import validator from 'validator';
import Axios from 'axios';
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'

class Contact extends Component {
   constructor(props) {
      super(props);
      this.state = {
         nome: '',
         mail: '',
         mensagem: '',
         valid: false
      };

      this.handleSubmit = this.handleSubmit.bind(this);
      this.validarEmail = this.validarEmail.bind(this);
   }

   handleSubmit(event) {
      if (!(this.state.nome && this.state.mail && this.state.mensagem)) {
         this.setState({ valid: false });

         return store.addNotification({
            title: "Warning!",
            message: "Fill in all fields.",
            type: "warning",
            insert: "top",
            container: "bottom-center",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
               duration: 2000,
               onScreen: true
            }
         });
      }

      this.validarEmail(this.state.mail);
   }

   validarEmail = (email) => {
      const emailValid = validator.isEmail(email)

      if (emailValid === false) {
         this.setState({ valid: false });

         return store.addNotification({
            title: "Warning!",
            message: "e-mail invalid",
            type: "warning",
            insert: "top",
            container: "bottom-center",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
               duration: 2000,
               onScreen: true
            }
         });
      }

      Axios.post("https://us-central1-serendipity-269321.cloudfunctions.net/sendMail", {
         nome: this.state.nome,
         mail: this.state.mail,
         mensagem: this.state.mensagem
      }).then(success => {
         this.setState({
            valid: false,
            nome: '',
            mail: '',
            mensagem: ''
         });

         return store.addNotification({
            title: "Thanks for writing. I’ll answer as soon as possible.",
            message: "Regards",
            type: "success",
            insert: "top",
            container: "bottom-center",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
               duration: 10000,
               onScreen: true
            }
         });
      }).catch(error => {
         return store.addNotification({
            title: "There was an error sending the email.",
            message: "Please try again later",
            type: "warning",
            insert: "top",
            container: "bottom-center",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
               duration: 2000,
               onScreen: true
            }
         });
      });
   }

   render() {
      return (
         <section id="contact">
            <div className="row section-head">
               <div className="two columns header-col">
                  <h1><span>Please fill in the box below to contact me.</span></h1>
               </div>
            </div>

            <div className="row">
               <div className="nine columns main-col">
                  <fieldset>
                     <div>
                        <label>Name <span className="required">*</span></label>
                        <input type="text" defaultValue="" size="35" value={this.state.nome} onChange={(event) => this.setState({ nome: event.target.value })} />
                     </div>

                     <div>
                        <label>E-mail <span className="required">*</span></label>
                        <input type="text" value={this.state.mail} onChange={(event) => this.setState({ mail: event.target.value })} />
                     </div>

                     <div>
                        <label>Message <span className="required">*</span></label>
                        <textarea cols="50" rows="15" value={this.state.mensagem} onChange={(event) => this.setState({ mensagem: event.target.value })}></textarea>
                     </div>

                     <div>
                        <button className="submit" onClick={this.handleSubmit}>Submit</button>
                        <span id="image-loader">
                           <img alt="" src="images/loader.gif" />
                        </span>
                     </div>
                  </fieldset>
               </div>
            </div>
         </section>
      );
   }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js